import React, { useEffect } from "react";
import services1 from "../assets/images/services1.webp";
import services8 from "../assets/images/services8.webp";
import services2 from "../assets/images/services2.webp";
import services3 from "../assets/images/services3.webp";
import services4 from "../assets/images/services4.webp";
import services5 from "../assets/images/services5.webp";
import services6 from "../assets/images/services6.webp";
import services7 from "../assets/images/services7.webp";

const services = [
  {
    id: "global-airline-ticketing",
    number: "01",
    label: "Global Airlines Ticketing",
    title: (
      <>
        Fly Anywhere.
        <br />
        <span>Travel Everywhere.</span>
      </>
    ),
    description:
      "Book domestic and international flights with access to leading airlines worldwide. Enjoy competitive fares, flexible options and seamless ticketing support. Book domestic and international flights with access to leading airlines worldwide. Enjoy competitive fares, flexible options and seamless ticketing support. Enjoy competitive fares, flexible options and seamless ticketing support.",
    points: ["Worldwide Airline Access", "Competitive Airfares"],
    button: "Book Your Flight",
    image: services1,
    tag: "FLIGHT BOOKING",
    icon: "✈",
  },
  {
    id: "worldwide-hotel-accommodation",
    number: "02",
    label: "Worldwide Hotel Accommodation",
    title: (
      <>
        Stay Better.
        <br />
        <span>Sleep Beautifully.</span>
      </>
    ),
    description:
      "Discover hotels, resorts and premium stays across the world. From business trips to luxury escapes, find accommodation that fits your journey perfectly. Discover hotels, resorts and premium stays across the world. From business trips to luxury escapes, find accommodation that fits your journey perfectly. Discover hotels, resorts and premium stays across the world. ",
    points: ["Hotels Worldwide", "Best Available Rates"],
    button: "Find Your Stay",
    image: services2,
    tag: "HOTEL ACCOMMODATION",
    icon: "⌂",
  },
  {
    id: "outbound-holiday-packages",
    number: "03",
    label: "Outbound Holiday Packages",
    title: (
      <>
        Discover More.
        <br />
        <span>Create Memories.</span>
      </>
    ),
    description:
      "Explore carefully designed international holiday packages covering destinations, stays, experiences and transfers for a completely hassle-free journey. Explore carefully designed international holiday packages covering destinations, stays, experiences and transfers for a completely hassle-free journey.Explore carefully designed international holiday packages covering destinations.",
    points: ["Curated Holiday Packages", "Complete Travel Assistance"],
    button: "Explore Packages",
    image: services3,
    tag: "HOLIDAY PACKAGES",
    icon: "✦",
  },
  {
    id: "global-visa-assistance",
    number: "04",
    label: "Global Visa Assistance",
    title: (
      <>
        Travel Without
        <br />
        <span>Visa Hassles.</span>
      </>
    ),
    description:
      "Get professional visa guidance for destinations around the world. Our experts assist with documentation, application procedures and the overall visa process. Get professional visa guidance for destinations around the world. Our experts assist with documentation, application procedures and the overall visa process. Our experts assist with documentation, application procedures and the overall visa process.",
    points: ["Worldwide Visa Support", "Document Assistance"],
    button: "Get Visa Assistance",
    image: services4,
    tag: "VISA ASSISTANCE",
    icon: "✈",
  },
  {
    id: "transfer-train-tickets",
    number: "05",
    label: "Transfers & Train Tickets",
    title: (
      <>
        Move With
        <br />
        <span>Complete Ease.</span>
      </>
    ),
    description:
      "Make every part of your journey comfortable with reliable airport transfers, private transportation and train ticket booking across popular destinations. Make every part of your journey comfortable with reliable airport transfers, private transportation and train ticket booking across popular destinations. Make every part of your journey comfortable with reliable airport transfers, private transportation.",
    points: ["Airport Transfers", "Train Ticket Booking"],
    button: "Plan Your Transfer",
    image: services5,
    tag: "TRANSFERS & TRAINS",
    icon: "➜",
  },
  {
    id: "inbound-outbound",
    number: "06",
    label: "Travel Insurance",
    title: (
      <>
        Travel Protected.
        <br />
        <span>Stay Confident.</span>
      </>
    ),
    description:
      "Protect your journey with travel insurance solutions designed for both inbound and outbound travellers, giving you greater confidence wherever you go. Protect your journey with travel insurance solutions designed for both inbound and outbound travellers, giving you greater confidence wherever you go. Protect your journey with travel insurance solutions designed for both inbound and outbound travellers.",
    points: ["Inbound Insurance", "Outbound Insurance"],
    button: "Get Insurance",
    image: services6,
    tag: "TRAVEL INSURANCE",
    icon: "✓",
  },
  {
    id: "uae-tourist-visa",
    number: "07",
    label: "UAE Tourist Visa",
    title: (
      <>
        Experience The
        <br />
        <span>UAE With Ease.</span>
      </>
    ),
    description:
      "Apply for your UAE tourist visa with simple and professional assistance. Get support with documentation and application processing for a smooth travel experience. Apply for your UAE tourist visa with simple and professional assistance. Get support with documentation and application processing for a smooth travel experience. Get support with documentation and application processing for a smooth travel experience.",
    points: ["UAE Tourist Visa", "Application Support"],
    button: "Apply for Visa",
    image: services7,
    tag: "UAE TOURIST VISA",
    icon: "✦",
  },
  {
    id: "client-assistance",
    number: "08",
    label: "24/7 Client Assistance",
    title: (
      <>
        We're With You.
        <br />
        <span>Anytime, Anywhere.</span>
      </>
    ),
    description:
      "Travel with complete peace of mind knowing our support team is available around the clock to assist you with your travel needs, questions and unexpected situations. Travel with complete peace of mind knowing our support team is available around the clock to assist you with your travel needs, questions and unexpected situations. Travel with complete peace of mind knowing our support team is available around the clock.",
    points: ["24/7 Travel Support", "Dedicated Assistance"],
    button: "Contact Us",
    image: services8,
    tag: "24/7 CLIENT ASSISTANCE",
    icon: "☎",
  },
];

const Services = () => {
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);
  return (
    <div className="min-h-screen overflow-hidden bg-[#F7FAFC]">
      {/* ANIMATION STYLES */}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-18px);
          }
        }

        @keyframes floatSlow {
          0%, 100% {
            transform: translate(0px, 0px);
          }
          50% {
            transform: translate(15px, -20px);
          }
        }

        @keyframes rotateSlow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes shine {
          0% {
            transform: translateX(-120%);
          }
          50%, 100% {
            transform: translateX(120%);
          }
        }

        @keyframes pulseGlow {
          0%, 100% {
            opacity: .35;
            transform: scale(1);
          }
          50% {
            opacity: .7;
            transform: scale(1.12);
          }
        }
      `}</style>

      {/* =========================================================
          HERO
      ========================================================== */}
      <section
        className="relative overflow-hidden bg-[#12344A]"
        style={{
          backgroundImage: `
             linear-gradient(120deg, rgb(34 75 139 / 98%) 0%, rgb(0 149 218 / 90%) 50%
50%
, rgb(0 195 230 / 82%) 100%), 
            url(${services1})
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* DARK PREMIUM OVERLAY */}
        <div className="absolute inset-0 bg-[#12344A]/20" />

        {/* GLOW CIRCLES */}
        <div
          className="absolute -right-40 -top-40 h-[550px] w-[550px] rounded-full bg-[#019EE7]/30 blur-[100px]"
          style={{ animation: "pulseGlow 6s ease-in-out infinite" }}
        />

        <div
          className="absolute -bottom-60 -left-40 h-[600px] w-[600px] rounded-full bg-[#97BF49]/25 blur-[120px]"
          style={{ animation: "pulseGlow 7s ease-in-out infinite" }}
        />

        {/* ROTATING CIRCLE */}
        <div
          className="absolute right-[8%] top-[12%] h-[430px] w-[430px] rounded-full border border-white/10"
          style={{ animation: "rotateSlow 35s linear infinite" }}
        />

        <div
          className="absolute right-[12%] top-[18%] h-[330px] w-[330px] rounded-full border border-white/10"
          style={{ animation: "rotateSlow 25s linear infinite reverse" }}
        />

        <div className="absolute right-[17%] top-[24%] h-[230px] w-[230px] rounded-full border border-white/10" />

        {/* FLOATING DOTS */}
        <div
          className="absolute left-[10%] top-[25%] h-3 w-3 rounded-full bg-[#97BF49] shadow-[0_0_25px_rgba(151,191,73,0.9)]"
          style={{ animation: "float 4s ease-in-out infinite" }}
        />

        <div
          className="absolute left-[18%] top-[70%] h-2 w-2 rounded-full bg-white/60"
          style={{ animation: "floatSlow 5s ease-in-out infinite" }}
        />

        <div
          className="absolute right-[10%] bottom-[22%] h-3 w-3 rounded-full bg-[#B4D86F] shadow-[0_0_20px_rgba(180,216,111,0.8)]"
          style={{ animation: "float 5s ease-in-out infinite" }}
        />

        <div className="absolute left-[50%] top-[18%] h-2 w-2 rounded-full bg-white/40" />

        {/* HERO CONTENT */}
        <div className="relative z-10 mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-36">
          <div className="mx-auto max-w-5xl md:text-center text-left">
            {/* BADGE */}
            <div className="mb-7 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-4 py-2 shadow-[0_10px_40px_rgba(0,0,0,0.15)] backdrop-blur-xl">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#97BF49] text-sm font-bold text-white shadow-[0_0_20px_rgba(151,191,73,0.55)]">
                ✦
              </span>

              <span className="text-xs font-bold uppercase tracking-[2px] text-white sm:text-sm">
                Explore. Experience. Escape.
              </span>
            </div>

            {/* HEADING */}
            <h1 className="text-[36px] font-black leading-[0.95] tracking-[-2px] text-white sm:text-6xl md:text-7xl lg:text-[78px]">
              Everything You Need
              <br />
              <span className="bg-gradient-to-r from-[#97BF49] via-[#B4D86F] to-white bg-clip-text text-transparent">
                to Travel
              </span>
            </h1>

            {/* DESCRIPTION */}
            <p className="mx-auto md:mt-7 mt-3 max-w-3xl text-base font-medium leading-8 text-white/85 md:text-lg">
              From global flights and worldwide hotels to unforgettable outbound
              holidays, discover seamless travel services designed around your
              comfort and convenience.
            </p>

            {/* HERO PILLS */}
            <div className="mt-9 flex flex-wrap md:justify-center justify-left gap-3">
              <div className="flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-3 shadow-lg backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:bg-white/15">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#97BF49] text-sm text-white">
                  ✓
                </span>

                <span className="text-sm font-semibold text-white">
                  Trusted Service
                </span>
              </div>

              <div className="flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-3 shadow-lg backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:bg-white/15">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#019EE7] text-sm text-white">
                  ★
                </span>

                <span className="text-sm font-semibold text-white">
                  Best Experiences
                </span>
              </div>

              <div className="flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-3 shadow-lg backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:bg-white/15">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#97BF49] text-sm text-white">
                  ♡
                </span>

                <span className="text-sm font-semibold text-white">
                  Personalised Trips
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM FADE */}
        {/* <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#F7FAFC] to-transparent" /> */}
      </section>

      <section className="relative bg-[#F7FAFC] py-12 lg:pt-28 ">
        <div className="relative mx-auto max-w-7xl md:px-0 px-6">
          <div className="space-y-12 md:space-y-24 ">
            {services.map((service, index) => (
              <div
                id={service.id}
                key={service.number}
                className={`md:scroll-mt-32 grid items-center gap-12 lg:grid-cols-2 lg:gap-20 ${
                  index % 2 !== 0 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="max-w-xl">
                  {/* LABEL */}
                  <div className="mb-2 flex items-center gap-3">
                    <span className="md:text-xl text-base font-bold tracking-[2px] text-sky-800">
                      {service.number}
                    </span>

                    <span className="h-px w-2 bg-sky-800" />

                    <span className="inline-block md:text-base text-sm font-bold tracking-[0.2em] text-sky-800">
                      {service.label}
                    </span>
                  </div>

                  {/* TITLE */}
                  <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-[0.2px] text-[#161A1D] sm:text-5xl lg:text-[58px]">
                    {service.title}
                  </h2>

                  {/* DESCRIPTION */}
                  <p className="md:mt-7 mt-4 max-w-lg text-base leading-8 text-slate-700 sm:text-lg">
                    {service.description}
                  </p>

                  {/* POINTS */}
                  <div className="md:mt-7 mt-3 flex flex-wrap items-center gap-4">
                    {service.points.map((point, pointIndex) => (
                      <React.Fragment key={point}>
                        <div className="flex items-center gap-2">
                          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#97BF49]/10">
                            <span className="h-2 w-2 rounded-full bg-[#97BF49] " />
                          </span>

                          <span className="text-sm font-medium text-slate-600">
                            {point}
                          </span>
                        </div>

                        {pointIndex < service.points.length - 1 && (
                          <span className="hidden h-5 w-px bg-slate-300 sm:block" />
                        )}
                      </React.Fragment>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="/contact"
                    className="capitalize group relative md:mt-9 mt-4 inline-flex items-center gap-3 overflow-hidden rounded-xl bg-gradient-to-r from-[#224B8B] via-[#0095DA] to-[#00C3E6] px-7 md:py-4 py-2 text-sm font-extrabold tracking-[1px] text-white  transition-all duration-300 hover:-translate-y-1"
                  >
                    <span className="relative">{service.button}</span>

                    <span className="relative text-xl transition-transform duration-300 group-hover:translate-x-1">
                      →
                    </span>
                  </a>
                </div>

                <div className="relative">
                  <div className="absolute -inset-8 rounded-[45px] bg-[#019EE7]/10 blur-3xl" />
                  <div
                    className="relative"
                    style={{
                      animation: "floatSlow 7s ease-in-out infinite",
                    }}
                  >
                    <div className="group relative overflow-hidden rounded-[32px] border border-white bg-white p-2">
                      <div className="relative h-[580px] overflow-hidden rounded-[26px]">
                        {/* IMAGE */}
                        <img
                          src={service.image}
                          alt={service.label}
                          className="h-full w-full object-cover transition duration-1000 group-hover:scale-110"
                        />
                        {/* <div className="absolute inset-0 bg-gradient-to-t from-[#12344A]/70 via-[#12344A]/10 to-transparent" /> */}
                        <div className="absolute left-6 top-6">
                          <div className="flex items-center gap-2 rounded-full border border-white/20 bg-[#12344A]/65 px-4 py-2.5 shadow-xl backdrop-blur-xl">
                            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#97BF49] text-sm text-white shadow-[0_0_15px_rgba(151,191,73,0.5)]">
                              {service.icon}
                            </span>

                            <span className="text-[10px] font-black tracking-[1.5px] text-white">
                              {service.tag}
                            </span>
                          </div>
                        </div>
                        <div
                          className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/10 blur-2xl"
                          style={{
                            animation: "pulseGlow 4s ease-in-out infinite",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="mx-auto max-w-7xl px-5 py-12">
        <img src={newbanner} className="w-full rounded-xl" />
      </section> */}
    </div>
  );
};

export default Services;
